import AbstractField from './abstract'

class CheckboxField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input[type="checkbox"]',
                actions: {
                    'change': this.changed.bind(this)
                }
            },
        }
    }
    __init(){
        this.registerEvents('changed')
    }
    changed(){
        this.dispatchEvent('changed')
    }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.checked
    }
    getValue(){
        return this.dom.input.checked
    }
}

export default CheckboxField